import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { Divider, Flex, Skeleton, Stack, ThemeIcon } from '@mantine/core';
import { ReactNode } from 'react';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

interface Props {
	list: {
		icon: PredefinedIcons;
		text: ReactNode;
	}[];
	isLoading: boolean;
}

export const VerticalTimeline = ({ list, isLoading }: Props) => {
	return (
		<Stack gap={0}>
			{isLoading ? (
				<Skeleton height={20} />
			) : (
				list.map(({ icon, text }, index) => (
					<Flex key={`${icon}-${index}`} direction="column" justify="center">
						{index !== 0 && (
							<Divider
								orientation="vertical"
								color="gray.4"
								w={1}
								h="1.5rem"
								ml={12}
							/>
						)}
						<Flex gap="0.5rem" align="center">
							<ThemeIcon radius="xl" color="gray.4">
								<Icon variant={icon} color="black" />
							</ThemeIcon>
							{text}
						</Flex>
					</Flex>
				))
			)}
		</Stack>
	);
};
